import { buildAskFliptSystemContext } from '../contexts/askflipt-context';

export async function executeAskFliptLoop(prompt: string, hasPdf: boolean): Promise<string> {
    const lowerPrompt = prompt.toLowerCase();
    
    // Trigger AskFlipt if the user mentions flashcards, quiz, study, or testing themselves
    const triggers = ['flashcard', 'quiz', 'study', 'test me', 'askflipt', 'flipcard'];
    
    if (triggers.some(t => lowerPrompt.includes(t)) || hasPdf) {
        // If they uploaded a PDF or explicitly asked for flashcards/quizzes, inject the capability instructions
        return buildAskFliptSystemContext();
    }
    
    return "";
}
